
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"6","viewBox":"0 0 32 6","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 .087h1.467c.274 0 .547.025.796.063 1.292.186 2.312.87 2.312 2.685 0 1.803-1.02 2.498-2.312 2.673a5.46 5.46 0 01-.796.05H0V.087zm29.812 2.325c.41-.05.745-.224.745-.746 0-.497-.335-.634-.745-.696h-.746v1.467h.348c.137 0 .273-.013.398-.025zm0-2.312c.97.037 1.864.236 1.864 1.48 0 .646-.41 1.18-1.093 1.267.286.037.46.323.559.572L32 5.557h-1.194l-.646-1.715c-.1-.249-.186-.398-.348-.485-.087-.05-.224-.075-.398-.075h-.348v2.275h-1.07V.087h1.157c.21 0 .447 0 .659.013zm-9.958 1.628c.124.323.186.684.186 1.094 0 .386-.062.759-.186 1.094-.386 1.057-1.318 1.74-2.598 1.74-1.716 0-2.81-1.168-2.81-2.834 0-1.678 1.119-2.822 2.81-2.822 1.28 0 2.212.672 2.598 1.728zm0-1.156l1.89 4.985h.397l2.101-5.47h-1.119l-1.119 2.884L20.811.087h-1.144l.187.485zm4.662-.485h3.182V.97h-2.1v1.343h1.913v.845h-1.914v1.541h2.114v.858h-3.195V.087zm-22.253.97A1.847 1.847 0 001.678.97H1.07V4.7h.61c.198 0 .397-.038.584-.1.659-.236 1.193-.845 1.193-1.765 0-.92-.534-1.554-1.193-1.778zm2.735-.97h1.081v5.47H4.998V.087zm4.55 1.455c-.373-.236-.77-.473-1.194-.522-.385-.05-.795.062-.795.609 0 .945 2.362.547 2.362 2.374 0 1.194-.945 1.778-2.026 1.654-.585-.063-.92-.237-1.38-.547V3.99c.36.2.895.585 1.317.66.46.074.958-.063.958-.56 0-1.056-2.35-.621-2.35-2.424C6.44.448 7.36 0 8.305 0c.472 0 .882.174 1.243.497v1.045zm4.624 3.468c-.273.349-.92.547-1.355.584-1.678.112-2.797-.82-2.797-2.672 0-1.865.982-2.959 2.797-2.86.36.013.945.137 1.33.46v1.045c-.46-.286-.932-.485-1.33-.497-1.106-.038-1.678.658-1.678 1.777 0 1.12.535 1.74 1.678 1.691.448-.012 1.12-.373 1.355-.572V5.01z","fill":"#fff"}})])
          )
        }
      }
    